export default __webpack_public_path__ + "static/media/Yuk3.74ce2495.JPG";